import { useSelector } from 'react-redux'

// Types
import type { State, SavedPaymentMethod } from 'types'

export const useSavedPaymentMethod = (): (SavedPaymentMethod & { expired: boolean }) | undefined => {
  const savedPaymentMethods = useSelector<State, SavedPaymentMethod | undefined>(state => state.pay.savedPaymentMethod)
  if (!savedPaymentMethods) {
    return savedPaymentMethods
  }
  const todayDate = new Date()
  const todayYear = +todayDate.getFullYear().toString().slice(2)
  const todayMonth = todayDate.getMonth() + 1 // months 0 indexed
  const yearExpired = todayYear > +savedPaymentMethods.exp_year
  const sameYear = todayYear === +savedPaymentMethods.exp_year
  const monthExpired = sameYear && todayMonth > +savedPaymentMethods.exp_month
  return {
    ...savedPaymentMethods,
    expired: (savedPaymentMethods.exp_year && savedPaymentMethods.exp_month && (yearExpired || monthExpired)) || false,
  }
}
